import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { endpoints } from "../../services/apiurl";
import { Card } from "@mui/material";
import PageTitle from "../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { InfinitySpin } from "react-loader-spinner";

const UserDetail = () => {
  let history = useHistory();
  let { restro_ids } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  var userInfo = {};

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);

  const columns = [
    {
      name: "NAME",
      selector: (row) => row.full_name,
    },
    {
      name: "RESTAURANTS NAME",
      selector: (row) => row.name,
    },
    {
      name: "STATUS",
      selector: (row) => (row.status == 1 ? "Active" : "Inactive"),
      // width: '200px'
    },
    {
      name: "ACTION",
      cell: (row) => (
        <div>
          {" "}
          <Link to={`/dashboard/edituser/${row.id}`}>
            {" "}
            <EditIcon />{" "}
          </Link>
          <Link
            className="trash alternate outline icon"
            style={{ marginTop: "7px", marginLeft: "10px" }}
            onClick={() => {
              const confirmBox = window.confirm(
                "Do you really want to delete?"
              );
              if (confirmBox === true) {
                removeContactHandler(row.id);
              }
            }}
          >
            {" "}
            <DeleteIcon />{" "}
          </Link>
        </div>
      ),
      selector: (row) => row.id,
      // width: '200px'
    },
  ];

  const removeContactHandler = async (id) => {
    await axios.post(endpoints.deleteUsers, { id }).then((response) => {});
    const newContactList = items.filter((contact) => {
      return contact.id !== id;
    });
    setItems(newContactList);
  };

  const fetchData = async (page, per_page) => {
    userInfo = JSON.parse(localStorage.getItem("user"));
    var restro_id = userInfo && userInfo.restro_id;
    await axios
      .post(endpoints.getUsers, {
        restro_id,
        page,
        per_page,
      })
      .then(
        (response) => {
          setIsLoaded(true);
          setItems(response.data.data);
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const handlePageChange = (page) => {
    fetchData(page, perPage, "");
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="spinner">
        <InfinitySpin
          visible={true}
          width="200"
          color="#fbaa1a"
          ariaLabel="infinity-spin-loading"
        />
      </div>
    );
  } else {
    return (
      <div className="App">
        <PageTitle
          title="Outlet User List"
          linkid={0}
          linkurl="/dashboard/adduser"
          linkTitle="Add User"
        />
        <Card className="px-3 py-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default UserDetail;
